// 전투 화면의 작은 표현 계약. 월드 규칙을 바꾸지 않고 Scene이 어떤
// 입력과 HP 정보를 보여 줄지만 결정한다. 순수 함수로 두어 카메라·입력
// 회귀를 Phaser 렌더러 없이도 검사할 수 있게 한다.

export const PLAYER_HP_BAR = Object.freeze({
  width: 64,
  height: 7,
  offsetY: 94,
  radius: 2,
});

export const MOUSE_AIM_MIN_DISTANCE = 8;
const AIM_EPSILON = 1e-6;

const finite = (value) => Number.isFinite(Number(value));
const clamp01 = (value) => Math.max(0, Math.min(1, Number(value) || 0));

export function playerHpBarState({
  hp,
  maxHp,
  shopOpen = false,
  escPaused = false,
  finale = false,
  over = false,
} = {}) {
  const maximum = Math.max(0, Number(maxHp) || 0);
  return {
    visible: maximum > 0 && !shopOpen && !escPaused && !finale && !over,
    ratio: maximum > 0 ? clamp01((Number(hp) || 0) / maximum) : 0,
  };
}

function setAim(out, aimX, aimY, aimActive, source) {
  out.aimX = aimX;
  out.aimY = aimY;
  out.aimActive = aimActive;
  out.source = source;
  return out;
}

/**
 * 오른쪽 스틱 > 마우스 포인터 > 기존 자동 조준 순서를 한 곳에서 고른다.
 * `pointer.positionToCamera` 는 Phaser가 제공하는 스크롤·줌 반영 월드 변환이다.
 * 호출자가 `pointerWorld`와 `out`을 재사용하면 프레임당 객체를 만들지 않는다.
 */
export function resolveCombatAim({
  gamepad = null,
  pointer = null,
  camera = null,
  player = null,
  mouseInside = false,
  mouseAllowed = false,
  pointerWorld = {},
} = {}, out = {}) {
  const padX = Number(gamepad?.aimX) || 0;
  const padY = Number(gamepad?.aimY) || 0;
  if (gamepad?.aimActive && Math.hypot(padX, padY) > AIM_EPSILON) {
    return setAim(out, padX, padY, true, 'gamepad');
  }

  if (!mouseAllowed || !mouseInside || pointer?.active !== true
      || !camera || !player || typeof pointer.positionToCamera !== 'function') {
    return setAim(out, 0, 0, false, 'auto');
  }

  const worldPoint = pointer.positionToCamera(camera, pointerWorld);
  if (!finite(worldPoint?.x) || !finite(worldPoint?.y)
      || !finite(player.x) || !finite(player.y)) {
    return setAim(out, 0, 0, false, 'auto');
  }
  const dx = Number(worldPoint.x) - Number(player.x);
  const dy = Number(worldPoint.y) - Number(player.y);
  if (Math.hypot(dx, dy) < MOUSE_AIM_MIN_DISTANCE) {
    return setAim(out, 0, 0, false, 'auto');
  }
  return setAim(out, dx, dy, true, 'mouse');
}
